import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";

import { Container } from "react-bootstrap";
import moment from "moment-timezone";
import NavigationTop from "../components/NavigationTop";
import { Outlet } from "react-router-dom";
import { useContext } from "react";
import { GlobalContext } from "../store";
import { Helmet } from "react-helmet";

const App: React.FC = () => {
    moment().tz("Europe/Bratislava").format();

    const store = useContext(GlobalContext);

    return (
        <div className="main">
            <Helmet>
                <title>Retro Games Slovakia</title>
                <meta name="author" content="Mário Herák, herakm@gmail.com" />
                <meta
                    name="description"
                    content="Vitajte na stránkach venovaných počítačovým hrám. Tieto stránky majú za cieľ zoznámiť vás s hrami z minulosti."
                    data-page-subject="true"
                />
                <meta
                    name="keywords"
                    content="retro, games, slovakia, 8-bit, 16-bit, 32-bit, pc, commodore, amiga, zx, spectrum, didaktik, ibm, hry, emulator"
                    data-page-subject="true"
                />
            </Helmet>

            <Container className="container-main">
                <NavigationTop user={store.loggedUser} />

                <Outlet />
            </Container>
        </div>
    );
};

export default App;
